
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent, identifyUser, setCustomTag, AnalyticsEvents } from '@/utils/analytics';
import { useAuth } from '@/contexts/AuthContext';

export const useAnalytics = () => {
  const location = useLocation();
  const { user } = useAuth();

  // Track page views
  useEffect(() => {
    trackEvent(AnalyticsEvents.PAGE_VIEWED, {
      path: location.pathname,
      timestamp: new Date().toISOString()
    });
  }, [location.pathname]);

  // Identify user when authenticated
  useEffect(() => {
    if (user) {
      identifyUser(user.id, {
        email: user.email,
        created_at: user.created_at,
        last_sign_in: user.last_sign_in_at
      });
      
      setCustomTag('user_type', 'authenticated');
    } else {
      setCustomTag('user_type', 'anonymous');
    }
  }, [user]);

  return {
    trackEvent,
    identifyUser,
    setCustomTag,
    events: AnalyticsEvents
  };
};
